import _ from "lodash";
import React from "react";
import classes from "./ItemViewFeed.scss";
import PropTypes from "prop-types";
import ACLStore from "lib/aclStore";

import UILabel from "UIComponents/UILabel";
import I18nHOC from "UIComponents/I18nHOC";
import {KeyboardNavigableList} from "UIComponents/KeyboardNavigableList";
import MoreItem from "./MoreItem";
import classNames from "classnames";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import { WarningTriangleOutlined } from "@toddle-edu/ds-icons";
import { UNIT_PLAN_MORE_DETAILS_IN_BANNER_PERMISSION } from "Constants/permissionConstants";

class ItemViewFeed extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showAll: props.showAllItems ? true : false };
    this.listContainerRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showAllItems !== this.props.showAllItems) {
      this.setState({ showAll: this.props.showAllItems });
    }
  }
  renderMoreCard = () => {};

  onMoreClick = e => {
    e.stopPropagation();
    this.setState({ showAll: true });
  };
  render() {
    const {
      label,
      subText,
      labelComponent,
      labelStyle,
      items,
      labelContainerStyle,
      maxItemCount,
      renderItem,
      itemText,
      emptyText,
      t,
      showAllItems,
      testId,
    } = this.props;
    const { showAll } = this.state;
    const itemLength = _.get(items, "length", 0);
    const maxItemCountValue =
      maxItemCount + 1 == itemLength ? itemLength : maxItemCount;
    const moreItemsCount = itemLength - maxItemCountValue;
    const updatedEmptyText = emptyText
      ? emptyText
      : `${t("common:no_label_added", { label: `${t(itemText)}` })}`;
    return (
      <div className={classes.container}>
        <UILabel
          label={label}
          subText={subText}
          labelComponent={labelComponent}
          labelStyle={labelStyle}
          labelContainerStyle={labelContainerStyle}
        />
        {itemLength > 0 ? (
          <div className={classes.feedContainer} ref={this.listContainerRef}>
            <KeyboardNavigableList
              listContainerRef={this.listContainerRef}
              shouldPreventDefault
            >
              {_.map(items, (item, index) => {
                if (
                  (index < maxItemCountValue || showAll) &&
                  !_.isEmpty(item)
                ) {
                  return (
                    <div
                      className={classNames({
                        [classes.itemCard]: true,
                        [classes.viewModeItemCard]: showAllItems,
                      })}
                      key={item?.id ? item.id : index}
                    >
                      {renderItem({ item, index })}
                    </div>
                  );
                }
              })}

              {moreItemsCount > 0 && !showAll && (
                <div className={classes.itemCard}>
                  <MoreItem
                    moreItemsCount={moreItemsCount}
                    itemText={t(itemText, { count: moreItemsCount })}
                    onMoreClick={this.onMoreClick}
                  />
                </div>
              )}
            </KeyboardNavigableList>
          </div>
        ) : (
          !!updatedEmptyText && (
            <div className={classes.emptyTextContainer}>
              <WarningTriangleOutlined variant="warning" size="xxx-small" />
              <div className={classes.emptyText}>{updatedEmptyText}</div>
            </div>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const isToddlePlay = _.get(state, "unitPlans.isToddlePlay", false);
  const showMoreDetailsInHeader = ACLStore.can(
    UNIT_PLAN_MORE_DETAILS_IN_BANNER_PERMISSION
  );

  const showAllItems = isToddlePlay || showMoreDetailsInHeader;
  return {
    showAllItems,
  };
};

export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, null)
)(ItemViewFeed);

ItemViewFeed.propTypes = {
  maxItemCount: PropTypes.number,
  emptyText: PropTypes.string,
};

ItemViewFeed.defaultProps = {
  maxItemCount: 1,
  emptyText: "",
  mode: "edit",
  isToddlePlay: false,
};
